
const messages = {
    en: {
       delivery: {
          order: {
            name: 'Order',
            title: 'Order management',
            subtitle: 'View, search, create, edit and delete Order',
            creating: 'Creating Order',
            editing: 'Editing Order',
            deleting: 'Deleting Order',
            showing: 'Showing Order',
            menu: 'Order',
            labels: {
                name: 'Name',
                phone: 'Phone',
                email: 'Email',
                address: 'Address',
                state: 'State',
                number: 'Number',
                deliveryUser: 'Delivery User'
            },

          }
       }
    },
    es: {
       delivery: {
          order: {
            name: 'Order',
            title: 'Administración de Order',
            subtitle: 'Ver, buscar, crear, editar, y borrar Order',
            creating: 'Creando Order',
            editing: 'Modificando Order',
            deleting: 'Eliminando Order',
            showing: 'Detalles de Order',
            menu: 'Order',
            labels: {
                name: 'Nombre',
                phone: 'Teléfono',
                email: 'Email',
                address: 'Dirección',
                state: 'Estado',
                number: 'Numero',
                deliveryUser: 'Repartidor'
            },

          }
       }
    },
    pt: {
       delivery: {
          order: {
            name: 'Order',
            title: 'Administração de Order',
            subtitle: 'Ver, buscar, criar, editar e usar Order',
            creating: 'Criando Order',
            editing: 'Edição Order',
            deleting: 'Apagando Order',
            showing: 'Detalhes do Order',
            menu: 'Order',
            labels: {
                name: 'Nome',
                phone: 'Telefono',
                email: 'Email',
                address: 'Dirección',
                state: 'Estado',
                number: 'Numero',
                deliveryUser: 'Delivery User'
            },

          }
       }
    }
}

export default messages
